import React from 'react';
import styled from 'styled-components';

import { Text } from '@paco_ua/pacoui';
import { Container } from 'semantic-ui-react';

import logoUA from 'assets/images/logo512.png';

const PageWarningComponent: React.FC<{ message: string; status?: string }> = ({
  message,
  status,
}) => {
  return (
    <Wrapper>
      <Container>
        <AlignCenter>
          <LogoUA src={logoUA} alt="Universidade de Aveiro" />
        </AlignCenter>
        <WrapperText>
          {status && (
            <FormattedText weight="bold">
              <AlignCenter>{status}</AlignCenter>
            </FormattedText>
          )}
          <FormattedText size="mediumSmall">
            <AlignCenter>{message}</AlignCenter>
          </FormattedText>
        </WrapperText>
      </Container>
    </Wrapper>
  );
};

export default PageWarningComponent;

const FormattedText: React.FC<{
  size?: string;
  color?: string;
  weight?: string;
  onClick?: () => void;
}> = ({ children, size, onClick, weight, color }) => (
  <div
    onClick={() => {
      onClick && onClick();
    }}
  >
    <Text color={'plusDarkGrey'} size={size ? size : 'large'} weight={weight}>
      {children}
    </Text>
  </div>
);

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  overflow: auto;
  padding: 0 26%;

  ${({ theme }) => theme.medias.sm} {
    padding: 0 20%;
    overflow: hidden;
  }

  ${({ theme }) => theme.medias.xs} {
    padding: 0 80px;
    overflow: hidden;
  }
`;

const LogoUA = styled.img`
  width: 80px;
  height: 80px;
  margin: 60px 0 80px;
`;

const AlignCenter = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`;

const WrapperText = styled.div`
  display: flex;
  flex-direction: column;

  > div:last-child {
    margin-bottom: 48px;
  }
`;
